import { type CVEditingSection } from '@cibli/shared';

import { useCVTranslation } from '@/features/cv/hooks/useCVTranslation.ts';

import EditableSection from '../../../components/form/EditableSection';

interface ProfileSectionProps {
  summary: string;
  onEdit?: (section: CVEditingSection) => void;
}

export default function ProfileSection({ summary, onEdit }: ProfileSectionProps) {
  const { t } = useCVTranslation();
  const editable = onEdit !== undefined;

  if (!summary && !editable) return null;

  const handleEdit = () => {
    if (onEdit) onEdit('summary');
  };

  return (
    <EditableSection onEdit={handleEdit} editable={editable}>
      <div className="mb-1 mx-0 px-0">
        <h2 className="text-[11px] font-black uppercase tracking-widest text-black mb-0.25">
          {t('CV.summary')}
        </h2>
        <p className="text-[11px] text-black leading-relaxed text-justify">
          {summary || (editable ? t('CV.summaryEmptyPlaceholder') : '')}
        </p>
      </div>
    </EditableSection>
  );
}
